import { createContext, useContext, useEffect, useState } from "react";
import TokenManager from "../../shared/storage/TokenManager";
import { clearPrefetchCache } from '../../shared/api/prefetchData';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [isAuth, setIsAuth] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isSessionExpired, setIsSessionExpired] = useState(false);

    useEffect(() => {
        (async () => {
            // ToDo: Cognito - disable
            // const token = await TokenManager.getAccessToken();
            const token = await TokenManager.getSessionToken();
            setIsAuth(!!token);
            setLoading(false);
        })();
    }, []);

    const login = async (tokens, options) => {
        await TokenManager.saveTokens(tokens, options);
        setIsAuth(true);
    };

    const logout = async (expired = false) => {
        await TokenManager.removeTokens();
        expired && setIsSessionExpired(true);
        clearPrefetchCache();
        setIsAuth(false);
    };

    return (
        <AuthContext.Provider value={{ isAuth, loading, login, logout, isSessionExpired }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
